import React, { useState } from "react";
import { CaretUpDown, Check } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { normPlate, truckLabel } from "./utils";

const NONE = "__none__";

const plateFilter = (value, search) =>
  value === NONE || normPlate(value).includes(normPlate(search)) ? 1 : 0;

export const TruckSelect = ({ trucks, value, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const current = trucks.find((t) => t.id === value);
  const pick = (id) => {
    setOpen(false);
    if (id !== (value || null)) onChange(id);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="h-10 w-full border border-zinc-900 bg-white px-3 text-sm flex items-center justify-between gap-2 hover:bg-zinc-50 transition-colors"
          data-testid={testId}
        >
          <span className={`truncate ${current ? "mono font-bold" : "text-zinc-500"}`}>
            {current ? truckLabel(current) : "— Aucun camion —"}
          </span>
          <CaretUpDown size={14} className="shrink-0 text-zinc-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 rounded-none border-2 border-zinc-900 w-[var(--radix-popover-trigger-width)] min-w-[240px]" align="start">
        <Command filter={plateFilter}>
          <CommandInput placeholder="Tapez une plaque…" className="h-10 border-0" data-testid={`${testId}-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty>Aucun camion trouvé.</CommandEmpty>
            <CommandGroup>
              <CommandItem value={NONE} onSelect={() => pick(null)} data-testid={`${testId}-option-none`}>
                <span className="text-zinc-500">— Aucun camion —</span>
              </CommandItem>
              {trucks.map((t) => (
                <CommandItem key={t.id} value={t.license_plate} onSelect={() => pick(t.id)} data-testid={`${testId}-option-${t.license_plate}`}>
                  <Check size={14} className={value === t.id ? "opacity-100" : "opacity-0"} />
                  <span className="mono">{truckLabel(t)}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
